import React from 'react'
import classnames from 'classnames'

const SquadList = ({
  team = {},
  hasSpace = false
}) => {
  const liClass = classnames(
    'cricinfo__content__detail__list__item',
    { 'cricinfo__content__detail__list__item--has-space' : hasSpace }
  )
  let playersList = (team.players || []).map((player) => {
    return player.name
  })

  playersList = playersList.join(', ')

  return (
    <li className={liClass}>
      <span className="cricinfo__type__weight--bold">{team.name}:</span>
      <span dangerouslySetInnerHTML={{ __html: playersList }}/>
    </li>
  )
}

const Squad = ({
  home = {},
  away = {}
}) => {
  return (
    <div className="cricinfo__content__item">
      <h2 className="cricinfo__sub-title">Squad</h2>
      <div className="cricinfo__content__detail">
        <ul className="cricinfo__content__detail__list">
          <SquadList team={home} />
          <SquadList team={away} hasSpace={true} />
        </ul>
      </div>
    </div>
  )
}

export default Squad



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/lite/Squad.jsx